const login = {
    state: {
        loginDialogVisible: false
    },
    mutations: {
        SHOW_LOGIN(state, newValue) {
            state.loginDialogVisible = newValue;
        }
    }
}
export default login